export default __webpack_public_path__ + "1JpJDc_-home.svg";